import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';

import { StageService } from '../../stage.service';
import { ProductsService } from '../../products.service';
import { DataForDisplayingMenuItemsService } from '../../data-for-displaying-menu-items.service';
import { ModelLoaderService } from '../../model-loader.service';
import { RailingPostsService } from '../post/services/railing-posts.service';
import { RailingCalculationHelperService } from './railing-calculation-helper.service';
import { RailingPostsForStairsService } from '../post/services/railing-posts-for-stairs.service';
import { RailingColorsService } from './railing-colors.service';
import { LoadingSpinnerService } from '../../loading-spinner.service';
import { SizeHelperService } from '../../size-helper.service';
import { ProjectManagerService } from '../../project-manager.service';
import { HelperLinesService } from '../../helper-lines.service';
import { StairRebuildService } from '../../stair-rebuild.service';
import { ConstantsService } from '../../constants.service';
import { DrawingsHolderService } from '../../proTools/drawings-holder.service';
import { InfillsService } from '../infills/infills.service';
import { RailingForTiersService } from './railing-for-tiers.service';
import { isPanelInfill } from '../infills/model/infill-types';
import { modernSpanInches } from '../../../models/2d3d/modern.config';
import { SceneLoadingService } from '../../scene-loading.service';

declare let THREE: any;

@Injectable()
export class RailingGenerationService {
  private currentParams: any = {};
  private dHeight: any;
  private showPostCaps: boolean = false;
  private isPostCapsVisible: boolean;
  private railingComponents: any = {
    intermediatePost: null,
    intermediatePostForStairs: null,
    intermediateAngledPost: null,
    lightedIntermidiatePost: null,
    cornerPost: null,
    cornerPostForStairs: null,
    cornerPost45degree: null,
    cornerPost135degree: null,
    lightedCornerPost: null,
    insideCornerPost: null,
    lightedInsideCornerPost: null,
    handrail: null,
    handrailForStairs: null,
    verticalCable: null,
    verticalCableForStairs: null,
    glass: null,
    baserail: null,
    verticalPicket: null,
    horizontalCableVerticalPicket: null,
    verticalPicketForStairs: null,
    horizontalCable: null,
    horizontalCableForStairs: null,
    postCapForCornerPost: null,
    postCapForIntermidiatePost: null,
    stairGlass: null,
    singleHorizontalCable: null,
    stairHandrailTopRight: null,
    stairHandrailTopLeft: null,
    stairHandrailBottomRight: null,
    stairHandrailBottomLeft: null,
    stairHandrailCenterRight: null,
    stairHandrailCenterLeftEntity: null,
    stairHandrailBracketRight: null,
    stairHandrailBracketLeft: null,
    stairHandrailResidentialTopRight: null,
    stairHandrailResidentialTopLeft: null,
    stairHandrailResidentialBottomRight: null,
    stairHandrailResidentialBottomLeft: null,
    horizontalCableForDoubleCornerWhithoutBaserail: null
  };
  private intermediatePoints: Array<any> = [];
  private cornerPoints: any = [];
  private Posts: Array<any> = [];
  private infills: Array<any> = [];
  private postCaps: Array<any> = [];
  private rotations: Array<any> = [];
  terminationPostsPositions: any = [];
  firstStartNewProj: boolean = true;
  isVisible: any = false;
  toggleRailingSubj = new Subject<any>();
  railingToggleUpdate = new Subject<any>();
  // private spotLight: any;
  build = new Subject<void>(); // not the best name
  readonly onRailStateChanged = new Subject<boolean>();

  constructor(
    private stage: StageService,
    private productSrvc: ProductsService,
    private dataForMenu: DataForDisplayingMenuItemsService,
    private modelLoaderService: ModelLoaderService,
    private railingPostsService: RailingPostsService,
    private railingCalculationHelperService: RailingCalculationHelperService,
    private infillsService: InfillsService,
    private postsForStairs: RailingPostsForStairsService,
    private railingForTiersService: RailingForTiersService,
    private railingColorsService: RailingColorsService,
    private loadingSpinnerService: LoadingSpinnerService,
    private sizeHelper: SizeHelperService,
    private projectSrvc: ProjectManagerService,
    private helperLinesService: HelperLinesService,
    private stairRebuildService: StairRebuildService,
    private constantsService: ConstantsService,
    private drawings: DrawingsHolderService,
    private sceneLoadingService: SceneLoadingService
  ) {
    this.currentParams = dataForMenu.getCurrentParams();

    this.dataForMenu.needRailingRebuild.subscribe(params => {
      this.currentParams = params;
      this.buildRailing(true);
    });
    this.dataForMenu.needRailingRebuildIfVisible.subscribe(params => {
      this.currentParams = params;
      this.buildRailingIfVisible();
    });
    this.dataForMenu.needRailingRebuildForHandrail.subscribe(params => {
      this.currentParams = params;
      this.buildRailingForHandrail();
    });

    this.dataForMenu.postCapsVisible.subscribe((visible: boolean) => {
      this.isPostCapsVisible = visible;
    });
  }

  getRailingComponent() {
    return this.railingComponents;
  }

  buildRailing(toggleRailing): Promise<any> {
    this.drawings.setSaved(false);

    if (toggleRailing) {
      this.isVisible = true;
      this.railingToggleUpdate.next(this.isVisible);
      this.updateCurrentParams();
      const heightForStairs = this.dataForMenu.currentChoises.railingHeightForStairs;
      const topRailForStairs = this.dataForMenu.currentChoises.topRailForStairs;

      const cornerPost = this.productSrvc.getCurrentCornerPost();

      this.constantsService.setSpaceForStairs(cornerPost.mountType.includes('Fascia'));

      const rebuildedStairs = [];
        // cornerPost.mountType && cornerPost.mountType.includes('Fascia')
        //   ? this.stairRebuildService.rebuildStairsForFasciaMount()
        //   : [];
      const isDockRail = this.currentParams.railingType === 'DockRail';
      const cornerPostEntity = this.productSrvc.getCurrentCornerPost();
      const intPostEntity = this.productSrvc.getCurrentIntermidiatePost();
      const handRailEntity = this.productSrvc.getCurrentHandrail();
      const intermediatePostForStairsEntity = this.productSrvc.getCurrentIntermidiatePost(
        heightForStairs
      );
      const handrailForStairsEntity = this.productSrvc.getCurrentHandrail(
        heightForStairs,
        topRailForStairs
      );
      const cornerPostEntityForStairs = this.productSrvc.getCurrentCornerPost(heightForStairs);

      const promises = [
        this.loadRailingComponent(cornerPostEntity, 'cornerPost'),
        this.loadRailingComponent(intPostEntity, 'intermediatePost'),
        this.loadRailingComponent(handRailEntity, 'handrail'),
        this.loadRailingComponent(intermediatePostForStairsEntity, 'intermediatePostForStairs'),
        this.loadRailingComponent(handrailForStairsEntity, 'handrailForStairs'),
        this.loadRailingComponent(cornerPostEntityForStairs, 'cornerPostForStairs')
      ];

      // DockRail has no post caps and no double-corner single cables in its catalog
      if (!isDockRail) {
        const singleHorizontalCable = this.productSrvc.getCurrentSingleHorizontalCable();
        const postCapForCornerPostEntity = this.productSrvc.getCurrentPostCapForCornerPost();
        const postCapForIntermidiatePostEntity = this.productSrvc.getCurrentPostCapForIntermidiatePost();
        promises.push(
          this.loadRailingComponent(singleHorizontalCable, 'singleHorizontalCable'),
          this.loadRailingComponent(postCapForCornerPostEntity, 'postCapForCornerPost')
        );
      } else {
        this.railingComponents.singleHorizontalCable = null;
        this.railingComponents.postCapForCornerPost = null;
        this.railingComponents.postCapForIntermidiatePost = null;
      }

      switch (this.currentParams.infill) {
        case 'horizontalCable':
          {
            const horizontalCableEntity = this.productSrvc.getCurrentHorizontalCable();
            const horizontalCableForStairsEntity = this.productSrvc.getCurrentHorizontalCable(
              heightForStairs
            );
            promises.push(
              this.loadRailingComponent(horizontalCableEntity, 'horizontalCable'),
              this.loadRailingComponent(horizontalCableForStairsEntity, 'horizontalCableForStairs')
            );
            // vertical pickets are not part of the DockRail catalog
            if (!isDockRail) {
              const verticalPicketEntity = this.productSrvc.getCurrentVerticalPicket();
              const horizontalCableVerticalPicketEntity = this.productSrvc.getCurrentHorizontalCableVerticalPicket();
              const verticalPicketForStairsEntity = this.productSrvc.getCurrentVerticalPicket();
              promises.push(
                this.loadRailingComponent(verticalPicketEntity, 'verticalPicket'),
                this.loadRailingComponent(
                  horizontalCableVerticalPicketEntity,
                  'horizontalCableVerticalPicket'
                ),
                this.loadRailingComponent(verticalPicketForStairsEntity, 'verticalPicketForStairs')
              );
            } else {
              this.railingComponents.verticalPicket = null;
              this.railingComponents.horizontalCableVerticalPicket = null;
              this.railingComponents.verticalPicketForStairs = null;
            }
          }
          break;
        case 'horizontalCableBaserail':
          {
            const horizontalCableEntity = this.productSrvc.getCurrentHorizontalCable();
            const horizontalCableForStairsEntity = this.productSrvc.getCurrentHorizontalCable(
              heightForStairs
            );
            const verticalPicketEntity = this.productSrvc.getCurrentVerticalPicket();
            const horizontalCableVerticalPicketEntity = this.productSrvc.getCurrentHorizontalCableVerticalPicket();
            const verticalPicketForStairsEntity = this.productSrvc.getCurrentVerticalPicket();
            const baserailEntity = this.productSrvc.getCurrentBaserail();
            promises.push(
              this.loadRailingComponent(horizontalCableEntity, 'horizontalCable'),
              this.loadRailingComponent(verticalPicketEntity, 'verticalPicket'),
              this.loadRailingComponent(
                horizontalCableVerticalPicketEntity,
                'horizontalCableVerticalPicket'
              ),
              this.loadRailingComponent(baserailEntity, 'baserail')
            );

            const horizontalCableForDoubleCornerWhithoutBaserailEntity = this.productSrvc.getCurrentHorizontalCableForDoubleCornerWhithoutBaserail();
            promises.push(
              this.loadRailingComponent(
                horizontalCableForDoubleCornerWhithoutBaserailEntity,
                'horizontalCableForDoubleCornerWhithoutBaserail'
              ),
              this.loadRailingComponent(horizontalCableForStairsEntity, 'horizontalCableForStairs'),
              this.loadRailingComponent(verticalPicketForStairsEntity, 'verticalPicketForStairs')
            );
          }
          break;

        default:
          // glass / laser-cut / steel-mesh panel infills (see InfillTypes)
          if (isPanelInfill(this.currentParams.infill)) {
            const productEntity = this.productSrvc.getCurrentInfillProduct(
              this.currentParams.infill
            );
            const baserailEntity = this.productSrvc.getCurrentBaserail();
            promises.push(
              this.loadRailingComponent(productEntity, this.currentParams.infill),
              this.loadRailingComponent(baserailEntity, 'baserail')
            );
          }
          break;
        case 'verticalCable':
          {
            const verticalCableEntity = this.productSrvc.getCurrentVerticalCable();
            const verticalCableForStairsEntity = this.productSrvc.getCurrentVerticalCable(
              heightForStairs
            );
            const baserailEntity = this.productSrvc.getCurrentBaserail();
            const verticalPicketEntity = this.productSrvc.getCurrentVerticalPicket();
            const verticalPicketForStairsEntity = this.productSrvc.getCurrentVerticalPicket();
            promises.push(
              this.loadRailingComponent(baserailEntity, 'baserail'),
              this.loadRailingComponent(verticalCableEntity, 'verticalCable'),
              this.loadRailingComponent(verticalPicketEntity, 'verticalPicket'),
              this.loadRailingComponent(verticalPicketForStairsEntity, 'verticalPicketForStairs'),
              this.loadRailingComponent(verticalCableForStairsEntity, 'verticalCableForStairs')
            );
          }
          break;
        case 'verticalPicket':
          {
            const verticalPicketEntity = this.productSrvc.getCurrentVerticalPicket();
            const verticalPicketForStairsEntity = this.productSrvc.getCurrentVerticalPicket();
            const baserailEntity = this.productSrvc.getCurrentBaserail();
            promises.push(
              this.loadRailingComponent(verticalPicketEntity, 'verticalPicket'),
              this.loadRailingComponent(baserailEntity, 'baserail'),
              this.loadRailingComponent(verticalPicketForStairsEntity, 'verticalPicketForStairs')
            );
          }
          break;
      }

      if (
        this.currentParams.postMounting === 'Fascia Bracket Mount' ||
        this.currentParams.postMounting === 'Fascia Mount'
      ) {
        // && this.currentParams.cornerPosts === "Single") {
        const insCornerPostEntity = this.productSrvc.getCurrentInsideCornerPost();
        promises.push(this.loadRailingComponent(insCornerPostEntity, 'insideCornerPost'));
      } else {
        this.railingComponents.insideCornerPost = null;
        this.railingComponents.lightedInsideCornerPost = null;
      }

      this.railingComponents.cornerPost45degree = this.railingComponents.cornerPost135degree = null;

      if (cornerPostEntity.model45Obj) {
        promises.push(
          this.loadRailingComponent(cornerPostEntity, 'cornerPost45degree', '45degree')
        );
      }

      if (cornerPostEntity.model135Obj) {
        promises.push(
          this.loadRailingComponent(cornerPostEntity, 'cornerPost135degree', '135degree')
        );
      }

      // add condition for loading stair handrails...
      // DockRail has no stair application — skip loading the 12 stair-handrail
      // models entirely (there are no DockRail stair products in the catalog).
      // Modern does get stairs; its stair rail reuses these shared models,
      // which getStairHandrails() resolves by productType alone.
      if (this.currentParams.railingType !== 'DockRail') {
      const stairHandrailTopRightEntity = this.productSrvc.getStairHandrails(
        'Stair Handrail Top Right'
      );
      const stairHandrailTopLeftEntity = this.productSrvc.getStairHandrails(
        'Stair Handrail Top Left'
      );
      const stairHandrailBottomRightEntity = this.productSrvc.getStairHandrails(
        'Stair Handrail Bottom Right'
      );
      const stairHandrailBottomLeftEntity = this.productSrvc.getStairHandrails(
        'Stair Handrail Bottom Left'
      );
      const stairHandrailCenterRightEntity = this.productSrvc.getStairHandrails(
        'Stair Handrail Center Right'
      );
      const stairHandrailCenterLeftEntity = this.productSrvc.getStairHandrails(
        'Stair Handrail Center Left'
      );
      const stairHandrailBracketRightEntity = this.productSrvc.getStairHandrails(
        'Stair Handrail Bracket Right'
      );
      const stairHandrailBracketLeftEntity = this.productSrvc.getStairHandrails(
        'Stair Handrail Bracket Left'
      );
      const stairHandrailResidentialTopRightEntity = this.productSrvc.getStairHandrails(
        'Stair Handrail Residential Top Right'
      );
      const stairHandrailResidentialTopLeftEntity = this.productSrvc.getStairHandrails(
        'Stair Handrail Residential Top Left'
      );
      const stairHandrailResidentialBottomRightEntity = this.productSrvc.getStairHandrails(
        'Stair Handrail Residential Bottom Right'
      );
      const stairHandrailResidentialBottomLeftEntity = this.productSrvc.getStairHandrails(
        'Stair Handrail Residential Bottom Left'
      );
      promises.push(
        this.loadRailingComponent(stairHandrailTopRightEntity, 'stairHandrailTopRight'),
        this.loadRailingComponent(stairHandrailTopLeftEntity, 'stairHandrailTopLeft'),
        this.loadRailingComponent(stairHandrailBottomRightEntity, 'stairHandrailBottomRight'),
        this.loadRailingComponent(stairHandrailBottomLeftEntity, 'stairHandrailBottomLeft'),
        this.loadRailingComponent(stairHandrailCenterRightEntity, 'stairHandrailCenterRight'),
        this.loadRailingComponent(stairHandrailCenterLeftEntity, 'stairHandrailCenterLeft'),
        this.loadRailingComponent(stairHandrailBracketRightEntity, 'stairHandrailBracketRight'),
        this.loadRailingComponent(stairHandrailBracketLeftEntity, 'stairHandrailBracketLeft'),
        this.loadRailingComponent(
          stairHandrailResidentialTopRightEntity,
          'stairHandrailResidentialTopRight'
        ),
        this.loadRailingComponent(
          stairHandrailResidentialTopLeftEntity,
          'stairHandrailResidentialTopLeft'
        ),
        this.loadRailingComponent(
          stairHandrailResidentialBottomRightEntity,
          'stairHandrailResidentialBottomRight'
        ),
        this.loadRailingComponent(
          stairHandrailResidentialBottomLeftEntity,
          'stairHandrailResidentialBottomLeft'
        )
      );
      }

      // for wood and composite railgin type
      // (because of the post thickness)
      // we need angled intermediate
      if (
        this.currentParams.railingType === 'Wood' ||
        this.currentParams.railingType === 'Composite'
      ) {
        // load angled models
        const intermediateAngledPostEntity = this.productSrvc.getCurrentIntermediateAngledPost();
        promises.push(
          this.loadRailingComponent(intermediateAngledPostEntity, 'intermediateAngledPost')
        );
      }

      promises.concat(rebuildedStairs);

      this.loadingSpinnerService.spinnerLoadingListAdd('RailingGenerationService');

      const promise = Promise.all(promises).then(res => {
        // for dev
        this.helperLinesService.removeTestMarkers();

        this.stage.removeMany(this.Posts);
        this.Posts = [];
        this.stage.removeMany(this.infills);
        this.infills = [];

        const floors = this.stage.getCompoundFloor();

        const floorsPosts = [];

        const floorsCornerPosts = [];

        for (let i = 0; i < floors.children.length; i++) {
          const floor = floors.children[i];

          this.dHeight = floor.getWorldPosition(new THREE.Vector3()).y;

          const projectType = this.projectSrvc.getProjectType();
          let maxWidth =
            projectType === 'business'
              ? this.sizeHelper.INCHToCM(60)
              : this.sizeHelper.INCHToCM(72);

          if (
            this.currentParams.infill === 'glass' ||
            (this.currentParams.infill === 'horizontalCable' &&
              this.currentParams.railingHeight === '42')
          ) {
            maxWidth = this.sizeHelper.INCHToCM(60);
          }

          if (
            this.currentParams.railingType === 'Steel flat bar' ||
            this.currentParams.railingType === 'Steel round tubular'
          ) {
            maxWidth = this.sizeHelper.INCHToCM(36);
          }

          if (this.currentParams.railingType === 'DockRail') {
            // DockRail Series 200 is engineered with 5-foot top rail sections
            // and pre-drilled posts — strict max post spacing of 60"
            maxWidth = this.sizeHelper.INCHToCM(60);
          }

          if (this.currentParams.railingType === 'Modern') {
            // the chosen kit length caps the post spacing (spec p.2 rule 1)
            maxWidth = this.sizeHelper.INCHToCM(
              modernSpanInches(this.currentParams.sectionSpan)
            );
          }

          const intAndTermPoints = this.railingCalculationHelperService.getPositionsForIntermediatePosts(
            floor,
            maxWidth,
            this.railingComponents.intermediatePost,
            this.railingComponents.cornerPost,
            this.railingComponents.cornerPost45degree,
            this.railingComponents.cornerPost135degree
          );
          this.intermediatePoints = intAndTermPoints.intermediatePoints;
          this.terminationPostsPositions = intAndTermPoints.terminationPostsPositions;

          floorsPosts.push(this.intermediatePoints);

          const cornerPosAndRot = this.railingCalculationHelperService.getPositionsForCornerPosts(
            floor,
            this.railingComponents.cornerPost,
            this.railingComponents.insideCornerPost,
            this.railingComponents.intermediatePost,
            this.railingComponents.cornerPost45degree,
            this.railingComponents.cornerPost135degree
          );
          this.cornerPoints = cornerPosAndRot.cornerPoints;
          this.rotations = cornerPosAndRot.rotations;

          const floorCornerPosts = this.cornerPoints.map((post, index) => ({
            ...post,
            rotation:
              cornerPost.mountType === 'Fascia Bracket Mount'
                ? this.rotations[index] + Math.PI / 2
                : this.rotations[index],
            visible: post.notCorner ? !post.notCorner : true
          }));

          floorsCornerPosts.push(floorCornerPosts);

          const horizontalCableForDoublePost =
            this.currentParams.infill === 'horizontalCableBaserail'
              ? this.railingComponents.horizontalCableForDoubleCornerWhithoutBaserail
              : this.railingComponents.horizontalCable;

          this.railingPostsService.buildPosts(
            floor,
            this.intermediatePoints,
            this.cornerPoints,
            this.railingComponents.cornerPost,
            this.rotations,
            this.railingComponents.horizontalCable,
            this.railingComponents.insideCornerPost,
            this.railingComponents.intermediatePost,
            this.terminationPostsPositions,
            this.railingComponents.cornerPost45degree,
            this.railingComponents.cornerPost135degree,
            this.Posts,
            this.currentParams.infill,
            horizontalCableForDoublePost,
            this.railingComponents.singleHorizontalCable
          );

          this.infillsService.addInfills(
            floor,
            this.cornerPoints,
            this.intermediatePoints,
            this.infills,
            this.dHeight,
            this.railingComponents
          );
        }

        // this.setPostCaps(this.showPostCaps);
        // DockRail: no stair application
        const stairsPosts =
          this.currentParams.railingType !== 'DockRail'
            ? this.postsForStairs.addHandrailAndBaserailForStairs(
                this.infills,
                this.railingComponents,
                this.Posts
              )
            : [];
        this.railingForTiersService.buildInfillsBetweenTiers(this.infills, this.railingComponents);
        this.loadingSpinnerService.spinnerLoadingListRemove('RailingGenerationService');
        this.onRailStateChanged.next(true);
        
        // Уведомляем SceneLoadingService о завершении построения перил
        setTimeout(() => {
          this.sceneLoadingService.forceCheck();
        }, 100);

        const VPPositions = [];
        this.infills.forEach(infill => {
          if (
            infill.userData.entity &&
            (infill.userData.entity.productType === 'Vertical Picket' ||
              infill.userData.entity.productType === 'Vertical Picket Without Baserail')
          ) {
            VPPositions.push(infill.position);
          }
        });

        this.setPostCapsVisibility(this.isPostCapsVisible);

        return {
          floorsPosts,
          floors: floors.children,
          stairsPosts,
          floorsCornerPosts,
          verticalPickets: VPPositions
        };
      });
      this.build.next();
      return promise;
    } else {
      this.stage.removeMany(this.Posts);
      this.Posts = [];
      this.stage.removeMany(this.infills);
      this.infills = [];
      this.stage.removeMany(this.postCaps);
      this.postCaps = [];

      this.isVisible = false;
      this.railingToggleUpdate.next(this.isVisible);
      this.onRailStateChanged.next(false);
      
      // Уведомляем SceneLoadingService об удалении перил
      setTimeout(() => {
        this.sceneLoadingService.forceCheck();
      }, 100);
      
      return Promise.resolve();
    }
  }

  IsVisible() {
    return this.isVisible;
  }

  private loadStairGlass(): Promise<any> {
    const promise = new Promise((resolve, reject) => {
      const stairGlassName = 'stair_glass_36';

      this.modelLoaderService.loadLocalModel(stairGlassName).then(model => {
        this.railingComponents.stairGlass = model.clone();
        resolve();
      });
    });
    return promise;
  }

  private loadRailingComponent(
    modelEntity,
    railingComponentType,
    specialModel?: string
  ): Promise<any> {
    return new Promise(resolve => {
      if (modelEntity) {
        this.modelLoaderService.loadModel(modelEntity, specialModel).then(model => {
          const object = model.clone();
          object.traverse(obj => {
            obj.castShadow =
              obj.name === 'Cap' ||
              obj.name === 'Post' ||
              obj.name === 'Handrail' ||
              obj.name === 'Bottomrail';
          });
          const isLaserCut =
            typeof modelEntity.productType === 'string' &&
            modelEntity.productType.indexOf('Laser Cut') === 0;
          object.children
            .filter(ch => {
              return (
                isLaserCut ||
                ch.name === 'Post' ||
                ch.name === 'Cap' ||
                ch.name === 'Handrail' ||
                ch.name === 'Bottomrail'
                // || ch.name === 'Pickets'
              );
            })
            .forEach(p => {
              const toStandard = old => {
                const s = new THREE.MeshStandardMaterial();
                s.copy(old);
                // local placeholder panels carve the perforation with an
                // alpha texture instead of cut-out geometry; keepAlphaMap
                // shields the map from the color services (they may only tint)
                if (isLaserCut && modelEntity.localAsset && s.map) {
                  s.alphaTest = 0.5;
                  s.transparent = false;
                  s.side = THREE.DoubleSide;
                  s.userData.keepAlphaMap = true;
                }
                return s;
              };
              // a mesh built from several usemtl groups carries an ARRAY of
              // materials — copying that as one Material throws in three.js
              p.material = Array.isArray(p.material)
                ? p.material.map(toStandard)
                : toStandard(p.material);
            });
          this.railingComponents[railingComponentType] = object;
          resolve();
        });
      } else resolve();
    });
  }

  updateCurrentParams() {
    this.currentParams = this.dataForMenu.getCurrentParams();
  }

  getIsShowPostCaps(): boolean {
    return this.showPostCaps;
  }

  setPostCapsVisibility(visible: boolean) {
    const caps = this.stage
      .getAllPosts()
      .map(c => c.children)
      .reduce((acc, val) => acc.concat(val), [])
      .filter(c => c && c.name.toLowerCase().includes('cap'));

    caps.forEach(cap => (cap.visible = visible));
  }

  setPostCaps(value): void {
    this.showPostCaps = value;
    this.stage.removeMany(this.postCaps);
    this.postCaps = [];
    if (value) {
      for (let i = 0; i < this.Posts.length; i++) {
        const post = this.Posts[i];
        let postCap;
        // cap components are not requested for DockRail — nothing to place
        if (post.userData.entity.productType === 'Intermediate Post' &&
            this.railingComponents.postCapForIntermidiatePost) {
          postCap = this.railingComponents.postCapForIntermidiatePost.clone();
        } else if (post.userData.entity.productType === 'Corner Post' &&
            this.railingComponents.postCapForCornerPost) {
          postCap = this.railingComponents.postCapForCornerPost.clone();
        } else {
          continue;
        }

        postCap.rotation.copy(post.rotation);
        postCap.position.set(
          post.position.x,
          post.position.y + post.userData.entity.height / 2 + postCap.userData.entity.height / 2,
          post.position.z
        );

        this.railingColorsService.setExistingColor(postCap, 'Post Cap', 'Cap');
        this.postCaps.push(postCap);
        this.stage.add(postCap);
      }
    }
  }

  buildRailingForHandrail() {
    if (this.isVisible) {
      this.loadingSpinnerService
        .spinnerLoadingListAddPromise('RailingGenerationService')
        .then(res => {
          this.buildRailing(true);
          this.loadingSpinnerService.spinnerLoadingListRemove('RailingGenerationService');
        });
    }
  }

  switchRailing() {
    this.toggleRailingSubj.next(false);
  }

  buildRailingIfVisible() {
    this.buildRailing(this.isVisible);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/railing/services/railing-generation.service.ts